import axiosInstance from "@/api/axios-instance";

export interface RescheduleBundleItem {
  managed_event_id: string;
  amount: number;
  name?: string;
}

export interface CreateRescheduleBundlesRequest {
  region_id: string;
  product_id?: string;
  show_to_public?: boolean;
  items: RescheduleBundleItem[];
}

export interface CreateRescheduleBundlesResult {
  created: number;
  skipped: number;
  bundles: unknown[];
}

export async function createRescheduleBundles(
  data: CreateRescheduleBundlesRequest,
): Promise<CreateRescheduleBundlesResult> {
  const response = await axiosInstance.post("/bundle/reschedule-batch", data);
  return response.data as CreateRescheduleBundlesResult;
}
